import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const paymentType = {
  path: '/normaCost',
  component: Layout,
  name: 'normaCost',
  redirect: '/normaCost/index',
  children: [{
    path: '/normaCost/index',
    component: () => import('@/views/normaCost/index'),
    name: 'normaCost.index',
    meta: {
      title: i18n.t(`message.normaCost`)
    }
  }, ]
}

export default paymentType